var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-card',{attrs:{"no-body":"","bg-variant":"light","border-variant":"light"}},[(_vm.orderSelected)?_c('fill-form-1',{on:{"displayResults":function($event){_vm.orderSelected = false;}}}):_c('form-1-case-information-search',{on:{"fillForm":_vm.startFillingForm1}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }